import { Controller } from "@hotwired/stimulus"
import autoAnimate from "@formkit/auto-animate"

// Connects to data-controller="auto-animate"
export default class extends Controller {
  static values = {
    duration: { type: Number, default: 250 },
    easing: { type: String, default: "ease-in-out" },
    disrespectUserMotionPreference: { type: Boolean, default: false }
  }

  connect() {
    this.animationController = autoAnimate(this.element, {
      duration: this.durationValue,
      easing: this.easingValue,
      disrespectUserMotionPreference: this.disrespectUserMotionPreferenceValue
    })
  }

  disconnect() {
    if (this.animationController) {
      this.animationController.disable()
    }
  }

  // Public methods to control animations
  enable() {
    if (this.animationController) {
      this.animationController.enable()
    }
  }

  disable() {
    if (this.animationController) {
      this.animationController.disable()
    }
  }

  toggle() {
    if (this.animationController) {
      // AutoAnimate doesn't have a built-in toggle, so we'll track state
      if (this.disabled) {
        this.enable()
        this.disabled = false
      } else {
        this.disable()
        this.disabled = true
      }
    }
  }

  // Handle value changes
  durationValueChanged() {
    this.reconnectAnimation()
  }

  easingValueChanged() {
    this.reconnectAnimation()
  }

  disrespectUserMotionPreferenceValueChanged() {
    this.reconnectAnimation()
  }

  // Private method to reconnect with new options
  reconnectAnimation() {
    if (this.animationController) {
      this.animationController.disable()
    }

    this.animationController = autoAnimate(this.element, {
      duration: this.durationValue,
      easing: this.easingValue,
      disrespectUserMotionPreference: this.disrespectUserMotionPreferenceValue
    })
  }
}
